module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Testimonials")]), _vm._v(" "), _c('ul', {
    staticClass: "articles"
  }, _vm._l((_vm.testimonials), function(test) {
    return _c('li', [_c('div', {
      staticClass: "article"
    }, [_c('p', {
      staticClass: "text_article"
    }, [_vm._v(_vm._s(test.content))]), _vm._v(" "), _c('cite', [_vm._v(_vm._s(test.author) + ",  "), _c('b', [_vm._v(_vm._s(test.type))])])]), _vm._v(" "), _c('div', {
      staticClass: "separator"
    })])
  })), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "7783278999",
      "ad-layout-key": "-8i+1w-dq+e9+ft",
      "ad-format": "fluid"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73da7f28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Testimonials.vue
// module id = 298
// module chunks = 1